import React, { useState } from 'react';
import { VQ } from '../../../../../store/student/types';
import {
  DateInputWithConfirm,
  InputWithConfirm,
  getStringFromDate,
  getDateFromString,
  ContinueButton,
  isValidDate,
} from 'shared-components';
import { IDate, ILeaveToRemain } from '../../../../../types';

interface IProps {
  index: number;

  applicationDate: string;
  applicationType: string;
  reference: string;

  onSaveAndClose: (leave: ILeaveToRemain) => void;
}

const LeaveToRemains = (props: IProps) => {
  const { index, onSaveAndClose } = props;
  const [dApplication, setDApplication] = useState(() => getDateFromString(props.applicationDate));
  const [dApplicationError, setDApplicationError] = useState('');
  const [applicationType, setApplicationType] = useState(props.applicationType);
  const [reference, setReference] = useState(props.reference);

  const saveAndClose = () => {
    onSaveAndClose({
      applicationDate: getStringFromDate(dApplication),
      applicationType,
      reference,
    });
  };

  const handleOnSaveAndCloseClick = (_event: React.MouseEvent<HTMLButtonElement>) => {
    saveAndClose();
  };

  const validateDate = (dateValue: IDate): string => {
    const { YYYY, DD, MM } = dateValue;

    if (YYYY && DD && MM) {
      const isValid = isValidDate(dateValue);
      if (!isValid) {
        return "Doesn't look like a valid date";
      }
      return '';
    }

    return '';
  };

  const complete =
    dApplication.DD !== null &&
    dApplication.MM !== null &&
    dApplication.YYYY !== null &&
    dApplicationError === '' &&
    applicationType !== '' &&
    reference !== '';

  return (
    <>
      <DateInputWithConfirm
        key={`${VQ.LEAVE_TO_REMAIN_DATE}-${index}`}
        id={`${VQ.LEAVE_TO_REMAIN_DATE}-${index}`}
        label={`Date of application`}
        value={dApplication}
        errorText={dApplicationError}
        onChangeDD={(evt: any) => setDApplication({ ...dApplication, DD: evt.target.value })}
        onChangeMM={(evt: any) => setDApplication({ ...dApplication, MM: evt.target.value })}
        onChangeYY={(evt: any) => setDApplication({ ...dApplication, YYYY: evt.target.value })}
        onBlur={(_evt: any) => setDApplicationError(validateDate(dApplication))}
      />
      <InputWithConfirm
        key={`${VQ.LEAVE_TO_REMAIN_TYPE}-${index}`}
        id={`${VQ.LEAVE_TO_REMAIN_TYPE}-${index}`}
        value={applicationType}
        label={`Type of application`}
        onChange={(evt: any) => {
          setApplicationType(evt.currentTarget.value);
        }}
      />
      <InputWithConfirm
        key={`${VQ.LEAVE_TO_REMAIN_REFERENCE}-${index}`}
        id={`${VQ.LEAVE_TO_REMAIN_REFERENCE}-${index}`}
        value={reference}
        label={`Home office Reference Number`}
        onChange={(evt: any) => {
          setReference(evt.currentTarget.value);
        }}
      />

      <ContinueButton index={index} complete={complete} handleOnSaveAndCloseClick={handleOnSaveAndCloseClick} />
    </>
  );
};

export default LeaveToRemains;
